import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/Grey/Chevron Down.svg'


const _withScopeId = n => (_pushScopeId("data-v-d54468e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "insight-coaching-list-card" }
const _hoisted_2 = {
  key: 0,
  class: "header desktop"
}
const _hoisted_3 = { class: "title left" }
const _hoisted_4 = { class: "title middle" }
const _hoisted_5 = { class: "title right" }
const _hoisted_6 = { class: "coaching-list-item desktop" }
const _hoisted_7 = { class: "left-container" }
const _hoisted_8 = { class: "middle-container" }
const _hoisted_9 = { class: "right-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "chevron"
}, null, -1))
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonCircle = _resolveComponent("SkeletonCircle")!
  const _component_SkeletonDiv = _resolveComponent("SkeletonDiv")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.header.titleLeft), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.header.titleMiddle), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.header.titleRight), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadingListItemCount, (currentCount, currentCountIdx) => {
        return (_openBlock(), _createElementBlock("div", { key: currentCountIdx }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_SkeletonCircle, { width: "44px" }),
              _createVNode(_component_SkeletonDiv, {
                class: "loading-title",
                width: "150px",
                height: "24px"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_SkeletonDiv, {
                class: "top-skeleton-bar",
                width: "130px",
                height: "12px"
              }),
              _createVNode(_component_SkeletonDiv, {
                width: "130px",
                height: "12px"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_SkeletonDiv, {
                class: "top-skeleton-bar",
                width: "80px",
                height: "12px"
              }),
              _createVNode(_component_SkeletonDiv, {
                width: "80px",
                height: "12px"
              })
            ]),
            _hoisted_10
          ]),
          (currentCount < _ctx.loadingListItemCount)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}